import { useParams, useNavigate } from 'react-router-dom';
import { Building2, MessageSquare } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface SettingsItem {
  title: string;
  description: string;
  icon: React.ElementType;
  path: string;
}

export function CompanySettingsPage(): React.ReactElement {
  const { companyId } = useParams<{ companyId: string }>();
  const navigate = useNavigate();

  const settingsItems: SettingsItem[] = [
    {
      title: 'Company Profile',
      description: 'Update company information and details',
      icon: Building2,
      path: `/companies/${companyId}/settings/profile`,
    },
    {
      title: 'Reference contact questions',
      description: 'Configure company-specific questions for reference contacts',
      icon: MessageSquare,
      path: `/companies/${companyId}/settings/referee-questions`,
    },
  ];

  return (
    <div className="container py-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Company Settings</h1>
        <p className="text-muted-foreground">Company configuration and preferences</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {settingsItems.map((item) => (
          <Card
            key={item.path}
            className="cursor-pointer hover:bg-muted/50 transition-colors"
            onClick={() => navigate(item.path)}
          >
            <CardHeader>
              <item.icon className="h-8 w-8 text-primary mb-2" />
              <CardTitle>{item.title}</CardTitle>
              <CardDescription>{item.description}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>
    </div>
  );
}
